import React, { useState, useEffect } from 'react';
import { collection, addDoc, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../config/firebaseConfig';
import { toast } from 'react-toastify';
import { PROJECT_DESIGN_OPTIONS } from '../../utils/projectDesign';
import styles from './AddProjectModal.module.css';
import {
  FaProjectDiagram,
  FaTimes,
  FaBuilding,
  FaUser,
  FaCalendarAlt,
  FaInfoCircle,
  FaFileContract,
  FaHospital,
  FaClipboardList,
  FaUserMd,
  FaMoneyBillWave,
} from 'react-icons/fa';
import Select from 'react-select';

const departments = [
  { value: 'Acil Tıp', label: 'Acil Tıp' },
  { value: 'Adli Tıp', label: 'Adli Tıp' },
  { value: 'Aile Hekimliği', label: 'Aile Hekimliği' },
  {
    value: 'Anesteziyoloji ve Reanimasyon',
    label: 'Anesteziyoloji ve Reanimasyon',
  },
  { value: 'Beyin ve Sinir Cerrahisi', label: 'Beyin ve Sinir Cerrahisi' },
  { value: 'Biyokimya', label: 'Biyokimya' },
  { value: 'Çocuk Cerrahisi', label: 'Çocuk Cerrahisi' },
  {
    value: 'Çocuk Sağlığı ve Hastalıkları',
    label: 'Çocuk Sağlığı ve Hastalıkları',
  },
  { value: 'Dahiliye', label: 'Dahiliye' },
  { value: 'Dermatoloji', label: 'Dermatoloji' },
  { value: 'Enfeksiyon Hastalıkları', label: 'Enfeksiyon Hastalıkları' },
  {
    value: 'Fiziksel Tıp ve Rehabilitasyon',
    label: 'Fiziksel Tıp ve Rehabilitasyon',
  },
  { value: 'Gastroenteroloji', label: 'Gastroenteroloji' },
  { value: 'Göğüs Cerrahisi', label: 'Göğüs Cerrahisi' },
  { value: 'Göğüs Hastalıkları', label: 'Göğüs Hastalıkları' },
  { value: 'Göz Hastalıkları', label: 'Göz Hastalıkları' },
  { value: 'Hematoloji', label: 'Hematoloji' },
  { value: 'Histoloji ve Embriyoloji', label: 'Histoloji ve Embriyoloji' },
  { value: 'İç Hastalıkları', label: 'İç Hastalıkları' },
  {
    value: 'Kadın Hastalıkları ve Doğum',
    label: 'Kadın Hastalıkları ve Doğum',
  },
  { value: 'Kalp ve Damar Cerrahisi', label: 'Kalp ve Damar Cerrahisi' },
  { value: 'Kardiyoloji', label: 'Kardiyoloji' },
  {
    value: 'Kulak Burun Boğaz (KBB) Hastalıkları',
    label: 'Kulak Burun Boğaz (KBB) Hastalıkları',
  },
  { value: 'Nefroloji', label: 'Nefroloji' },
  { value: 'Nöroloji', label: 'Nöroloji' },
  { value: 'Ortopedi ve Travmatoloji', label: 'Ortopedi ve Travmatoloji' },
  { value: 'Patoloji', label: 'Patoloji' },
  {
    value: 'Plastik, Rekonstrüktif ve Estetik Cerrahi',
    label: 'Plastik, Rekonstrüktif ve Estetik Cerrahi',
  },
  { value: 'Psikiyatri', label: 'Psikiyatri' },
  { value: 'Radyasyon Onkolojisi', label: 'Radyasyon Onkolojisi' },
  { value: 'Radyoloji', label: 'Radyoloji' },
  { value: 'Spor Hekimliği', label: 'Spor Hekimliği' },
  { value: 'Tıbbi Biyoloji', label: 'Tıbbi Biyoloji' },
  { value: 'Tıbbi Farmakoloji', label: 'Tıbbi Farmakoloji' },
  { value: 'Tıbbi Genetik', label: 'Tıbbi Genetik' },
  { value: 'Tıbbi Mikrobiyoloji', label: 'Tıbbi Mikrobiyoloji' },
  { value: 'Tıbbi Onkoloji', label: 'Tıbbi Onkoloji' },
  { value: 'Tıbbi Patoloji', label: 'Tıbbi Patoloji' },
  { value: 'Üroloji', label: 'Üroloji' },
];

const centerTypes = [
  { value: 'Ev', label: 'Ev' },
  { value: 'Hastane', label: 'Hastane' },
  { value: 'Eş Zamanlı', label: 'Eş Zamanlı' },
];

const phases = [
  { value: 'Faz I', label: 'Faz I' },
  { value: 'Faz II', label: 'Faz II' },
  { value: 'Faz III', label: 'Faz III' },
  { value: 'Düşük Riskli Bilimsel Çalışma', label: 'Düşük Riskli Bilimsel Çalışma' },
  { value: 'Beşeri Tıbbi Ürünlerin Adaptif Tasarımlı Klinik Araştırması (Faz I/II)', label: 'Beşeri Tıbbi Ürünlerin Adaptif Tasarımlı Klinik Araştırması (Faz I/II)' },
  { value: 'Beşeri Tıbbi Ürünlerin Adaptif Tasarımlı Klinik Araştırması (Faz I/III)', label: 'Beşeri Tıbbi Ürünlerin Adaptif Tasarımlı Klinik Araştırması (Faz I/III)' },
  { value: 'Beşeri Tıbbi Ürünlerin Adaptif Tasarımlı Klinik Araştırması (Faz II/III)', label: 'Beşeri Tıbbi Ürünlerin Adaptif Tasarımlı Klinik Araştırması (Faz II/III)' },
  { value: 'Sağlık Beyanlı Ürün/Yöntem Çalışması', label: 'Sağlık Beyanlı Ürün/Yöntem Çalışması' },
  { value: 'Beşeri Tıbbi Ürünlerin Gözlemsel Çalışması', label: 'Beşeri Tıbbi Ürünlerin Gözlemsel Çalışması' },
  { value: 'Kök hücreler ile yapılan klinik araştırması', label: 'Kök hücreler ile yapılan klinik araştırması' },
];

const AddProjectModal = ({ onClose, onUpdate }) => {
  const [formData, setFormData] = useState({
    customer: '',
    coordinatorAcademician: '',
    ethicsCommitteeDate: '',
    ethicsCommitteeNumber: '',
    ethicsCommitteePlace: '',
    firstInvoiceDate: '',
    paymentFrequency: '',
    projectCentersType: '',
    projectDate: '',
    projectDepartment: '',
    projectDueDate: '',
    projectPhase: '',
    // Çift kör / open label / hibrit. Hibrit projede primer+blinded çalışanın
    // açtığı vizit unblinded çalışanın takvimine de düşer (utils/hybridVisitMirror.js)
    projectDesign: '',
    protocolNumber: '',
    sbFirstApprovalDate: '',
    sbFirstApprovalNumber: '',
    sbProjectNumber: '',
    titleLong: '',
    titleShort: '',
    center: '',
    isCurrencyFixed: false,
    fixedCurrencyRate: '',
  });

  const [customers, setCustomers] = useState([]);
  const [centers, setCenters] = useState([]);
  const [externalPersonnels, setExternalPersonnels] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'Customers'));
        const customersData = querySnapshot.docs
          .map((doc) => ({
            value: doc.data().Başlık,
            label: doc.data().Başlık,
          }))
          .filter((item) => item.label)
          .sort((a, b) => a.label.localeCompare(b.label));
        setCustomers(customersData);
      } catch (error) {
        console.error('Error fetching customers:', error);
        toast.error('Müşteriler yüklenirken bir hata oluştu!');
      }
    };

    fetchCustomers();
  }, []);

  useEffect(() => {
    const fetchCenters = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'Centers'));
        const centersData = querySnapshot.docs
          .map((doc) => ({
            value: doc.data().Adı,
            label: doc.data().Adı,
          }))
          .sort((a, b) => a.label.localeCompare(b.label));
        setCenters(centersData);
      } catch (error) {
        console.error('Error fetching centers:', error);
        toast.error('Merkezler yüklenirken bir hata oluştu!');
      }
    };

    fetchCenters();
  }, []);

  useEffect(() => {
    const fetchExternalPersonnels = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'ExternalPersonnels'));
        const personnelsData = querySnapshot.docs
          .map((doc) => {
            const data = doc.data();
            const fullName = `${data['Adı'] || ''} ${data['Soyadı'] || ''}`.trim();
            return {
              value: fullName,
              label: fullName,
            };
          })
          .filter((item) => item.label)
          .sort((a, b) => a.label.localeCompare(b.label, 'tr'));
        setExternalPersonnels(personnelsData);
      } catch (error) {
        console.error('Error fetching external personnels:', error);
        toast.error('Harici personeller yüklenirken bir hata oluştu!');
      }
    };

    fetchExternalPersonnels();
  }, []);

  const handleChange = (e) => {
    if (e?.target) {
      const { name, value } = e.target;
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleSelectChange = async (selectedOption) => {
    try {
      // Get the customer document that matches the selected customer
      const customersRef = collection(db, 'Customers');
      const q = query(
        customersRef,
        where('Başlık', '==', selectedOption.value)
      );
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const customerData = querySnapshot.docs[0].data();
        const odemePeriyodu = customerData['Ödeme Periyodu'];

        setFormData((prevState) => ({
          ...prevState,
          customer: selectedOption.value,
          paymentFrequency: odemePeriyodu || '', // Set payment frequency if it exists
        }));
      } else {
        setFormData((prevState) => ({
          ...prevState,
          customer: selectedOption.value,
        }));
      }
    } catch (error) {
      console.error('Error fetching customer data:', error);
      toast.error('Müşteri bilgileri alınırken bir hata oluştu!');
      // Still update the customer even if there's an error
      setFormData((prevState) => ({
        ...prevState,
        customer: selectedOption.value,
      }));
    }
  };

  const handleDepartmentChange = (selectedOption) => {
    setFormData((prevState) => ({
      ...prevState,
      projectDepartment: selectedOption.value,
    }));
  };

  const handleCenterTypeChange = (selectedOption) => {
    setFormData((prevState) => ({
      ...prevState,
      projectCentersType: selectedOption.value,
    }));
  };

  const handlePhaseChange = (selectedOption) => {
    setFormData((prevState) => ({
      ...prevState,
      projectPhase: selectedOption.value,
    }));
  };

  const handleCenterChange = (selectedOption) => {
    setFormData((prevState) => ({
      ...prevState,
      center: selectedOption.value,
    }));
  };

  const handleCoordinatorChange = (selectedOption) => {
    // isClearable: temizlendiğinde selectedOption null gelir
    setFormData((prevState) => ({
      ...prevState,
      coordinatorAcademician: selectedOption ? selectedOption.value : '',
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate required fields
    if (!formData.titleShort || !formData.customer) {
      toast.error('Lütfen gerekli alanları doldurunuz!');
      return;
    }
    // Validate fixed currency if selected
    if (formData.isCurrencyFixed) {
      const rateNum = parseFloat(formData.fixedCurrencyRate);
      if (!rateNum || rateNum <= 0) {
        toast.error(
          'Sabit kur seçildi. Lütfen geçerli bir kur değeri giriniz.'
        );
        return;
      }
    }

    setLoading(true);

    try {
      // Add the project first
      const projectRef = await addDoc(collection(db, 'Projects'), formData);
      const projectId = projectRef.id;
      
      // Define the specific users who should get tasks
      const targetEmails = [
        'melisa.sener@habcarecro.com',
        'aygul.dag@habcarecro.com',
        'ozge.yikimlar@habcarecro.com'
      ];

      // Fetch employee data for these specific emails
      const employeesQuery = query(
        collection(db, 'Employees'),
        where('eMail', 'in', targetEmails)
      );
      const employeesSnapshot = await getDocs(employeesQuery);
      
      // Create tasks for each target employee
      const taskPromises = employeesSnapshot.docs.map(async (empDoc) => {
        const empData = empDoc.data();
        const taskData = {
          title: `Yeni Proje: ${formData.titleShort}`,
          description: `${formData.customer} müşterisi için yeni proje oluşturuldu. Proje detaylarını inceleyiniz ve gerekli işlemleri başlatınız.`,
          assigneeId: empDoc.id,
          assigneeName: `${empData.eName || ''} ${empData.eSurname || ''}`.trim(),
          assignees: [{
            id: empDoc.id,
            name: `${empData.eName || ''} ${empData.eSurname || ''}`.trim(),
            email: empData.eMail
          }],
          priority: 'medium',
          status: 'pending',
          category: 'Proje Yönetimi',
          projectId: projectId,
          projectName: formData.titleShort,
          customerName: formData.customer,
          createdAt: new Date(),
          updatedAt: new Date(),
          dueDate: formData.projectDueDate ? new Date(formData.projectDueDate) : null,
          createdBy: 'System',
          requestType: 'PROJECT_TASK'
        };

        return addDoc(collection(db, 'Tasks'), taskData);
      });

      // Wait for all tasks to be created
      await Promise.all(taskPromises);
      
      toast.success(`Proje başarıyla eklendi! ${employeesSnapshot.docs.length} kişi için görev oluşturuldu.`);
      onUpdate();
      onClose();
    } catch (error) {
      console.error('Error adding project:', error);
      toast.error('Proje eklenirken bir hata oluştu!');
    } finally {
      setLoading(false);
    }
  };

  const customSelectStyles = {
    control: (base) => ({
      ...base,
      backgroundColor: 'var(--input-bg)',
      borderColor: 'var(--input-border)',
      minHeight: '42px',
      borderRadius: '6px',
      boxShadow: 'none',
      '&:hover': {
        borderColor: 'var(--input-focus-border)',
      },
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: 'var(--modal-bg)',
      zIndex: 9999,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused
        ? 'var(--input-focus-border)'
        : 'var(--modal-bg)',
      color: state.isFocused ? 'white' : 'var(--modal-text)',
      '&:hover': {
        backgroundColor: 'var(--input-focus-border)',
        color: 'white',
      },
    }),
    singleValue: (base) => ({
      ...base,
      color: 'var(--modal-text)',
    }),
    input: (base) => ({
      ...base,
      color: 'var(--modal-text)',
    }),
    placeholder: (base) => ({
      ...base,
      color: 'var(--input-placeholder)',
    }),
  };

  const ToggleSwitch = ({
    checked,
    onChange,
    labels = { on: 'Evet', off: 'Hayır' },
  }) => {
    const trackStyle = {
      width: '56px',
      height: '28px',
      borderRadius: '999px',
      background: checked ? 'var(--input-focus-border)' : 'var(--input-border)',
      position: 'relative',
      cursor: 'pointer',
      transition: 'background 0.2s ease',
      display: 'inline-flex',
      alignItems: 'center',
      padding: '0 6px',
    };
    const thumbStyle = {
      width: '22px',
      height: '22px',
      borderRadius: '50%',
      background: 'var(--modal-bg)',
      position: 'absolute',
      top: '3px',
      left: checked ? '31px' : '3px',
      transition: 'left 0.2s ease',
    };
    const labelStyle = {
      marginLeft: '10px',
      color: 'var(--modal-text)',
    };
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div
          role="switch"
          aria-checked={checked}
          onClick={() => onChange(!checked)}
          style={trackStyle}
        >
          <div style={thumbStyle} />
        </div>
        <span style={labelStyle}>{checked ? labels.on : labels.off}</span>
      </div>
    );
  };

  return (
    <div className={styles.modalBackdrop}>
      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>
            <FaProjectDiagram className={styles.modalIcon} />
            Yeni Proje Ekle
          </h2>
          <button
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Kapat"
          >
            <FaTimes />
          </button>
        </div>

        <div className={styles.modalContent}>
          <div className={styles.formGroup}>
            <div className={styles.formControl}>
              <label className={styles.label}>
                <FaBuilding style={{ marginRight: '8px' }} />
                Müşteri *
              </label>
              <Select
                value={customers.find((c) => c.value === formData.customer)}
                onChange={handleSelectChange}
                options={customers}
                isSearchable={true}
                placeholder="Müşteri seçiniz..."
                className={styles.select}
                styles={customSelectStyles}
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>
                <FaInfoCircle style={{ marginRight: '8px' }} />
                Proje Adı (Kısa) *
              </label>
              <input
                type="text"
                name="titleShort"
                value={formData.titleShort}
                onChange={handleChange}
                placeholder="Kısa başlık giriniz..."
                required
                className={styles.input}
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>
                <FaInfoCircle style={{ marginRight: '8px' }} />
                Proje Adı (Uzun)
              </label>
              <textarea
                name="titleLong"
                value={formData.titleLong}
                onChange={handleChange}
                placeholder="Uzun başlık giriniz..."
                className={styles.textarea}
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>
                <FaUserMd style={{ marginRight: '8px' }} />
                Proje Departmanı
              </label>
              <Select
                value={departments.find(
                  (d) => d.value === formData.projectDepartment
                )}
                onChange={handleDepartmentChange}
                options={departments}
                isSearchable={true}
                placeholder="Departman seçiniz..."
                className={styles.select}
                styles={customSelectStyles}
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>
                <FaClipboardList style={{ marginRight: '8px' }} />
                Proje Design
              </label>
              <Select
                value={PROJECT_DESIGN_OPTIONS.find((d) => d.value === formData.projectDesign) || null}
                onChange={(selectedOption) =>
                  setFormData((prevState) => ({ ...prevState, projectDesign: selectedOption?.value || '' }))
                }
                options={PROJECT_DESIGN_OPTIONS}
                isClearable
                placeholder="Çift kör, open label veya hibrit..."
                className={styles.select}
                styles={customSelectStyles}
              />
              {formData.projectDesign === 'hybrid' && (
                <small style={{ display: 'block', marginTop: '6px', opacity: 0.8 }}>
                  Hibrit projede primer ve blinded çalışanın açtığı vizit, projeye bağlı unblinded
                  çalışanın takvimine de otomatik düşer.
                </small>
              )}
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>
                <FaClipboardList style={{ marginRight: '8px' }} />
                Proje Aşaması
              </label>
              <Select
                value={phases.find((p) => p.value === formData.projectPhase)}
                onChange={handlePhaseChange}
                options={phases}
                isSearchable={true}
                placeholder="Aşama seçiniz..."
                className={styles.select}
                styles={customSelectStyles}
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>
                <FaHospital style={{ marginRight: '8px' }} />
                Proje Merkezi Tipi
              </label>
              <Select
                value={centerTypes.find(
                  (c) => c.value === formData.projectCentersType
                )}
                onChange={handleCenterTypeChange}
                options={centerTypes}
                isSearchable={true}
                placeholder="Merkez tipi seçiniz..."
                className={styles.select}
                styles={customSelectStyles}
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>
                <FaBuilding style={{ marginRight: '8px' }} />
                Merkez
              </label>
              <Select
                value={centers.find((c) => c.value === formData.center)}
                onChange={handleCenterChange}
                options={centers}
                isSearchable={true}
                placeholder="Merkez seçiniz..."
                className={styles.select}
                styles={customSelectStyles}
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>
                <FaMoneyBillWave style={{ marginRight: '8px' }} />
                Kur Sabitlemesi Yapıldı mı?
              </label>
              <ToggleSwitch
                checked={!!formData.isCurrencyFixed}
                onChange={(val) =>
                  setFormData((prev) => ({ ...prev, isCurrencyFixed: val }))
                }
              />
            </div>

            {formData.isCurrencyFixed && (
              <div className={styles.formControl}>
                <label className={styles.label}>
                  <FaMoneyBillWave style={{ marginRight: '8px' }} />
                  Sabit Kur Değeri (Kaçtan?)
                </label>
                <input
                  type="number"
                  step="0.0001"
                  min="0"
                  name="fixedCurrencyRate"
                  value={formData.fixedCurrencyRate}
                  onChange={handleChange}
                  placeholder="Örn: 32.1500"
                  className={styles.input}
                  required
                />
              </div>
            )}

            <div className={styles.formControl}>
              <label className={styles.label}>
                <FaCalendarAlt style={{ marginRight: '8px' }} />
                Proje Tarihi
              </label>
              <input
                type="date"
                name="projectDate"
                value={formData.projectDate}
                onChange={handleChange}
                className={styles.input}
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>
                <FaCalendarAlt style={{ marginRight: '8px' }} />
                Proje Bitiş Tarihi
              </label>
              <input
                type="date"
                name="projectDueDate"
                value={formData.projectDueDate}
                onChange={handleChange}
                className={styles.input}
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>
                <FaCalendarAlt style={{ marginRight: '8px' }} />
                Etik Kurul Tarihi
              </label>
              <input
                type="date"
                name="ethicsCommitteeDate"
                value={formData.ethicsCommitteeDate}
                onChange={handleChange}
                className={styles.input}
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>
                <FaFileContract style={{ marginRight: '8px' }} />
                Etik Kurul Numarası
              </label>
              <input
                type="text"
                name="ethicsCommitteeNumber"
                value={formData.ethicsCommitteeNumber}
                onChange={handleChange}
                placeholder="Etik kurul numarası giriniz..."
                className={styles.input}
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>
                <FaBuilding style={{ marginRight: '8px' }} />
                Etik Kurul Yeri
              </label>
              <input
                type="text"
                name="ethicsCommitteePlace"
                value={formData.ethicsCommitteePlace}
                onChange={handleChange}
                placeholder="Etik kurul yerini giriniz..."
                className={styles.input}
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>
                <FaCalendarAlt style={{ marginRight: '8px' }} />
                SB İlk Onay Tarihi
              </label>
              <input
                type="date"
                name="sbFirstApprovalDate"
                value={formData.sbFirstApprovalDate}
                onChange={handleChange}
                className={styles.input}
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>
                <FaFileContract style={{ marginRight: '8px' }} />
                SB İlk Onay Numarası
              </label>
              <input
                type="text"
                name="sbFirstApprovalNumber"
                value={formData.sbFirstApprovalNumber}
                onChange={handleChange}
                placeholder="SB ilk onay numarasını giriniz..."
                className={styles.input}
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>
                <FaFileContract style={{ marginRight: '8px' }} />
                SB Proje Numarası
              </label>
              <input
                type="text"
                name="sbProjectNumber"
                value={formData.sbProjectNumber}
                onChange={handleChange}
                placeholder="SB proje numarasını giriniz..."
                className={styles.input}
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>
                <FaUser style={{ marginRight: '8px' }} />
                Koordinatör Akademisyen
              </label>
              <Select
                value={externalPersonnels.find(
                  (p) => p.value === formData.coordinatorAcademician
                )}
                onChange={handleCoordinatorChange}
                options={externalPersonnels}
                isSearchable={true}
                placeholder="Koordinatör akademisyen seçiniz..."
                className={styles.select}
                styles={customSelectStyles}
                isClearable={true}
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>
                <FaFileContract style={{ marginRight: '8px' }} />
                Protokol Numarası
              </label>
              <input
                type="text"
                name="protocolNumber"
                value={formData.protocolNumber}
                onChange={handleChange}
                placeholder="Protokol numarasını giriniz..."
                className={styles.input}
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>
                <FaCalendarAlt style={{ marginRight: '8px' }} />
                İlk Fatura Tarihi
              </label>
              <input
                type="date"
                name="firstInvoiceDate"
                value={formData.firstInvoiceDate}
                onChange={handleChange}
                className={styles.input}
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>
                <FaMoneyBillWave style={{ marginRight: '8px' }} />
                Ödeme Sıklığı
              </label>
              <input
                type="text"
                name="paymentFrequency"
                value={formData.paymentFrequency}
                onChange={handleChange}
                placeholder="Ödeme sıklığını giriniz..."
                className={styles.input}
              />
            </div>
          </div>
        </div>

        <div className={styles.modalFooter}>
          <button
            className={styles.cancelButton}
            onClick={onClose}
            disabled={loading}
          >
            İptal
          </button>
          <button
            className={styles.addButton}
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? (
              <>
                <div className={styles.loadingSpinner}></div>
                Ekleniyor...
              </>
            ) : (
              'Proje Ekle'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddProjectModal;
